import * as React from 'react';

import './Block.scss';

export const BlockImage = ({ title, url, width, height }: any) => (
  <div className="block-image">
    <img src={url} style={{ width, aspectRatio: `${width}/${height}` }} alt={title} />
  </div>
);
